import React, { useState, useEffect, useRef } from 'react'
import '../../assets/style.css'
import Config from '../../core/config/'
import {
  makeRequest,
  makeRequestWithErrorMessage
} from '../../core/services/v1/request'
import $ from 'jquery'
import NavbarOne from '../separate/NavbarOne'
import { showNumber, showPairNameUsdt } from '../../core/helper/date-format'
import { useContextData } from '../../core/context'
import { toast } from '../../core/lib/toastAlert'
import axios from 'axios'
import { Typography } from '@mui/material'
import { Helmet } from 'react-helmet-async'
import LoaderSpin from '../../Component/Loader/LoaderSpin'
import LoaderUnitic from '../../Component/Loader/LoaderUnitic'
import { countDecimals } from '../../core/helper/common'
import SpotMyOrdersUsdt from '../separate/usdtTrading/SpotMyOrdersUsdt'
import SpotOrderBookUsdt from '../separate/usdtTrading/SpotOrderBookUsdt'
import SpotRecentUsdt from '../separate/usdtTrading/SpotRecentUsdt'
import SpotMenuUsdt from '../separate/usdtTrading/SpotMenuUsdt'
import TradingViewSpot from '../separate/usdtTrading/tradeChartUsdt/trading-view-usdt'
import SpotTradeFormUsdt from '../separate/usdtTrading/SpotTradeFormUsdt'
import OrderConfirmationUsdt from '../separate/usdtTrading/dialogsUsdt/OrderConfirmationUsdt'
import ModifyOrderUsdt from '../separate/usdtTrading/dialogsUsdt/ModifyOrderUsdt'
import ModifyMarginUsdt from '../separate/usdtTrading/dialogsUsdt/ModifyMarginUsdt'
import AdjustLeverageUsdt from '../separate/usdtTrading/dialogsUsdt/AdjustLeverageUsdt'
import MarginModeUsdt from '../separate/usdtTrading/dialogsUsdt/MarginModeUsdt'
import SpotInfoUsdt from '../separate/usdtTrading/infoUsdt/InfoUsdt'
import SpotTradingDataUsdt from '../separate/usdtTrading/SpotTradingDataUsdt'
import socketIOClient from 'socket.io-client'
import { getCookie } from '../../core/helper/cookie'
import { createTradingAccount } from '../../core/context/helper'

function formatNumber(num = 0) {
  num = Number(num)
  if (num == 0) return 0
  const suffixes = ['', 'K', 'M', 'B', 'T']
  const factor = 1000

  let suffixIndex = 0
  let formattedNumber = num

  while (formattedNumber >= factor && suffixIndex < suffixes.length - 1) {
    formattedNumber /= factor
    suffixIndex++
  }
  return `${formattedNumber.toFixed(2)}${suffixes[suffixIndex]}`
}
function createSymbolMap(symbolArray = null) {
  return symbolArray.reduce((map, symbolData) => {
    map[symbolData.symbol] = symbolData
    return map
  }, {})
}

function decimalValue(value, decimal = 0) {
  if (decimal === 0) {
    return showNumber(parseFloat(value))
  }
  return showNumber(parseFloat(value).toFixed(decimal))
}
function generateId() {
  return '_spot_' + Date.now() + (Math.random() * 365).toString(16).slice(4, 14)
}

const initialState = {
  bids: [],
  asks: [],
  ts: 0
}
const initialBackPages = {
  openOrders: false,
  stopOrders: false,
  orders: false,
  fills: false
}
let priceObj = null
let userTokenChk = 0
const SpotTradeUsdt = props => {
  const [orderListType, setOrderListType] = useState('all')
  const containerRef = useRef(null)
  const containerSecondRef = useRef(null)
  const [pairDetails, setPairDetails] = useState({
    prevPrice: 0,
    data: {},
    market: {},
    baseDecimal: null,
    quoteDecimal: null,
    priceDecimal: null,
    rate: null,
    pairDB: {},
    fees: {}
  })
  const [isOverflowing, setIsOverflowing] = useState(false)
  const [isOverflowingSecond, setIsOverflowingSecond] = useState(false)
  const [currentPage_tradeHis, setCurrentPage_tradeHis] = useState(1)
  const [socketConnection, setSocketConnection] = useState(null)
  const [socketConnectionKucoin, setSocketConnectionKucoin] = useState(null)
  const [socketConnectionKucoinV2, setSocketConnectionKucoinV2] = useState(null)
  const [tradesShow, setTradesShow] = useState(0)
  const [firstOptionPart, setFirstOptionPart] = useState(0)
  const [pairsData, setPairsData] = useState([])
  const [symbolsData, setSymbols] = useState([])
  const [pairsLoader, setPairsLoader] = useState(true)
  const [orderFetchLoading, setOrderFetchLoading] = useState(true)
  const [priceStatic, setPriceStatic] = useState()
  const [orderBookData, setOrderBookData] = useState(initialState)
  const [recentTradesData, setRecentTradesData] = useState({})
  const [walletData, setWalletData] = useState([])
  const [trades, setTrades] = useState({
    dataLimit: 20,
    openOrders: [],
    stopOrders: [],
    orders: [],
    fills: []
  })
  const [tradesBackPage, setTradesPages] = useState(initialBackPages)
  const [crossMenu, setCrossMenu] = useState('isolated')
  const [xMenu, setXMenu] = useState(1)
  const [tpPx, setTpPx] = useState()
  const [slPx, setSlPx] = useState()
  const [amount, setAmount] = useState(null)
  const [quantity, setQuantity] = useState(null)
  const [openOrderConfirmation, setOpenOrderConfirmation] =
    React.useState(false)
  const [tradeParams, setTradeParams] = React.useState({})
  const [favs, setFavs] = useState(null)
  const wsRefPvt = useRef(null);
  const wsRef = useRef(null);
  const pingRef = useRef(null);
  const reconnectRef = useRef(0);
  const orderBookRef = useRef(initialState);

  // const { pairName } = useParams();
  const { pairName, handleNavigation, navigate } = props;
  const handleClickOpenOrderConfirmation = tradeParams => {
    setTradeParams(() => tradeParams)
    setOpenOrderConfirmation(true)
  }
  const handleCloseOrderConfirmation = () => {
    setOpenOrderConfirmation(false)
  }
  const [openModifyOrder, setOpenModifyOrder] = React.useState(false)

  const handleClickOpenModifyOrder = () => {
    setOpenModifyOrder(true)
  }
  const handleCloseModifyOrder = () => {
    setOpenModifyOrder(false)
  }
  const [openModifyMargin, setOpenModifyMargin] = React.useState(false)

  const handleClickOpenModifyMargin = () => {
    setOpenModifyMargin(true)
  }
  const handleCloseModifyMargin = () => {
    setOpenModifyMargin(false)
  }
  const [openAdjust, setOpenAdjust] = React.useState(false)

  const handleClickOpenAdjust = () => {
    setOpenAdjust(true)
  }
  const handleCloseAdjust = () => {
    setOpenAdjust(false)
  }
  const [openMarginMode, setOpenMarginMode] = React.useState(false)

  const handleClickOpenMarginMode = () => {
    setOpenMarginMode(true)
  }
  const handleCloseMarginMode = () => {
    setOpenMarginMode(false)
  }
  const {
    myProfile,
    setUserProfile,
    spotBalance,
    setSpotUsdtBalance,
    dispatch
  } = useContextData()
  const formatSymbolName = (baseCurrency = '', quoteCurrency = '') => {
    if (baseCurrency === 'XBT') {
      baseCurrency = 'BTC'
    }
    const quoteCurrencyEdition = (
      <span style={{ color: '#C8C8C8' }}>{quoteCurrency}</span>
    )
    const symbolEdition = (
      <span className='fw-bold text-capitalize'>
        {baseCurrency + '/'}
        {quoteCurrencyEdition}
      </span>
    )
    return symbolEdition
  }
  function formatWithK(value, deci = 2) {
    if (!value) return value
    value = Number(value)
    if (value >= 1000) {
      return (value / 1000).toFixed(2) + 'K'
    }
    return value.toFixed(deci)
  }
  // const asksModify = async (a1, a2, getBaseDecimal, getPriceDecimal) => {
  //   let baseDeci = getBaseDecimal || priceObj.baseDecimal || pairDetails.baseDecimal;
  //   let priceDeci = getPriceDecimal || priceObj.priceDecimal || pairDetails?.priceDecimal;
  //   if (!baseDeci) {
  //     baseDeci = countDecimals(a2?.[0]?.[1])
  //   }
  //   if (!priceDeci) {
  //     priceDeci = countDecimals(a2?.[0]?.[0])
  //   }
  //   const depthMap = new Map()
  //   const pricesSet = new Set()
  //   let totalQuantity = 0

  //   // Populate depthMap with a1
  //   a1.reverse().forEach((depth, index, array) => {
  //     // if (depth.length === 4) {
  //     const price =
  //       priceObj?.changeValue > 0
  //         ? (priceObj?.changePer * +depth[0]).toFixed(priceDeci)
  //         : depth[0]
  //     const quantity = parseFloat(depth[1]) // Multiply by 0.01
  //     totalQuantity += quantity
  //     const orders = formatWithK(totalQuantity, baseDeci) // Calculate orders based on cumulative sum
  //     depthMap.set(price, [
  //       price,
  //       formatWithK(quantity, baseDeci),
  //       orders.toString()
  //     ])
  //     pricesSet.add(price)
  //     // }
  //   })

  //   // Iterate over a2
  //   totalQuantity = 0 // Reset totalQuantity
  //   a2.reverse().forEach((depth, index, array) => {
  //     // if (depth.length === 4) {
  //     const price =
  //       priceObj?.changeValue > 0
  //         ? (priceObj?.changePer * +depth[0]).toFixed(priceDeci)
  //         : depth[0]
  //     const size = parseFloat(depth[1]) // Multiply by 0.01
  //     totalQuantity += size
  //     const orders = formatWithK(totalQuantity, baseDeci) // Calculate orders based on cumulative sum

  //     if (size === 0) {
  //       // If size is 0, delete the depth from depthMap and pricesSet
  //       depthMap.delete(price)
  //       pricesSet.delete(price)
  //     } else {
  //       // If size is not 0
  //       if (pricesSet.has(price)) {
  //         // If price exists in a1, update the depthMap
  //         depthMap.set(price, [price, formatWithK(size, baseDeci), orders])
  //       } else {
  //         // If price does not exist in a1, add it to depthMap and pricesSet
  //         depthMap.set(price, [price, formatWithK(size, baseDeci), orders])
  //         pricesSet.add(price)
  //       }
  //     }
  //     // }
  //   })

  //   // Convert depthMap back to array and sort
  //   const result = Array.from(depthMap.values()).sort(
  //     (a, b) => parseFloat(a[0]) - parseFloat(b[0])
  //   )

  //   return result
  // }
  // const bidsModify = async (a1, a2, getBaseDecimal, getPriceDecimal) => {
  //   let baseDeci =
  //     getBaseDecimal || priceObj?.baseDecimal || pairDetails?.baseDecimal
  //   let priceDeci =
  //     getPriceDecimal || priceObj.priceDecimal || pairDetails?.priceDecimal
  //   if (!baseDeci) {
  //     baseDeci = countDecimals(a2?.[0]?.[1])
  //   }
  //   if (!priceDeci) {
  //     priceDeci = countDecimals(a2?.[0]?.[0])
  //   }
  //   const depthMap = new Map()
  //   const pricesSet = new Set()
  //   let totalQuantity = 0

  //   // Populate depthMap with a1
  //   a1.forEach((depth, index) => {
  //     // if (depth.length === 4) {
  //     const price =
  //       priceObj?.changeValue > 0
  //         ? (priceObj?.changePer * +depth[0]).toFixed(priceDeci)
  //         : depth[0]
  //     const quantity = parseFloat(depth[1]) // Multiply by 0.01
  //     totalQuantity += quantity
  //     const orders = formatWithK(totalQuantity, baseDeci) // Calculate orders based on cumulative sum
  //     depthMap.set(price, [price, formatWithK(quantity, baseDeci), orders]) // Round to 2 decimal places
  //     pricesSet.add(price)
  //     // }
  //   })

  //   // Iterate over a2
  //   totalQuantity = 0 // Reset totalQuantity
  //   a2.forEach((depth, index) => {
  //     // if (depth.length === 4) {
  //     const price =
  //       priceObj?.changeValue > 0
  //         ? (priceObj?.changePer * +depth[0]).toFixed(priceDeci)
  //         : depth[0]
  //     const size = parseFloat(depth[1]) // Multiply by 0.01
  //     totalQuantity += size
  //     const orders = formatWithK(totalQuantity, baseDeci) // Calculate orders based on cumulative sum

  //     if (size === 0) {
  //       // If size is 0, delete the depth from depthMap and pricesSet
  //       depthMap.delete(price)
  //       pricesSet.delete(price)
  //     } else {
  //       // If size is not 0
  //       if (pricesSet.has(price)) {
  //         // If price exists in a1, update the depthMap
  //         depthMap.set(price, [price, formatWithK(size, baseDeci), orders]) // Round to 2 decimal places
  //       } else {
  //         // If price does not exist in a1, add it to depthMap and pricesSet
  //         depthMap.set(price, [price, formatWithK(size, baseDeci), orders]) // Round to 2 decimal places
  //         pricesSet.add(price)
  //       }
  //     }
  //     // }
  //   })

  //   // Convert depthMap back to array and sort
  //   const result = Array.from(depthMap.values()).sort(
  //     (a, b) => parseFloat(b[0]) - parseFloat(a[0])
  //   )

  //   return result
  // }

  const asksModify = async (oldAsks, newAsks, baseDeci, priceDeci) => {
    const depthMap = new Map()

    oldAsks.forEach(([p, q]) => {
      depthMap.set(p, parseFloat(q))
    })

    newAsks.forEach(([p, q]) => {
      const qty = parseFloat(q)
      if (qty === 0) depthMap.delete(p)
      else depthMap.set(p, qty)
    })

    let cumulative = 0

    return Array.from(depthMap.entries())
      .sort((a, b) => parseFloat(a[0]) - parseFloat(b[0]))
      .map(([price, qty]) => {
        cumulative += qty
        return [
          price,
          formatWithK(qty, baseDeci),
          formatWithK(cumulative, baseDeci)
        ]
      })
  }
  const bidsModify = async (oldBids, newBids, baseDeci, priceDeci) => {
    const depthMap = new Map()

    oldBids.forEach(([p, q]) => {
      depthMap.set(p, parseFloat(q))
    })

    newBids.forEach(([p, q]) => {
      const qty = parseFloat(q)
      if (qty === 0) depthMap.delete(p)
      else depthMap.set(p, qty)
    })

    let cumulative = 0

    return Array.from(depthMap.entries())
      .sort((a, b) => parseFloat(b[0]) - parseFloat(a[0]))
      .map(([price, qty]) => {
        cumulative += qty
        return [
          price,
          formatWithK(qty, baseDeci),
          formatWithK(cumulative, baseDeci)
        ]
      })
  }
  const orderBookDataCalculation = async (
    oldBids,
    oldAsks,
    newBids,
    newAsks,
    getBaseDecimal = null,
    getQuoteDecimal = null
  ) => {
    try {
      if (
        !priceObj ||
        priceObj == null ||
        !priceObj?.changePer ||
        priceObj?.changePer == null
      )
        return
      const modifiedBids = await bidsModify(
        oldBids,
        newBids,
        getBaseDecimal,
        getQuoteDecimal
      )
      const modifiedAsks = await asksModify(
        oldAsks,
        newAsks,
        getBaseDecimal,
        getQuoteDecimal
      )
      orderBookRef.current = {
        bids: modifiedBids,
        asks: modifiedAsks
      };
      setOrderBookData(() => {
        return {
          bids: modifiedBids,
          asks: modifiedAsks
        }
      })
    } catch (error) {
      console.error('Error modifying data:', error)
      setOrderBookData(() => {
        return {
          bids: [],
          asks: []
        }
      })
    }
  }
  const pairDataFetch = async () => {
    setPairsLoader(true)
    await axios
      .get(`${Config?.V3_API_URL}trade/get-pair?pair=${pairName}`)
      .then(res => {
        if (res.data?.data?.orderBook.retCode != 0 || !res.data?.status) {
          toast({
            type: 'error',
            message: res.data?.data?.orderBook?.retMsg || 'An error ocurred!'
          })
          return handleNavigation('BTC-USDT')
        }
        const newAsks = res.data?.data?.orderBook?.result?.a || []
        const newBids = res.data?.data?.orderBook?.result?.b || []
        const oldBids = orderBookData?.bids || []
        const oldAsks = orderBookData?.asks || []
        const getQuoteDecimal = countDecimals(
          res.data?.data?.pair?.data?.lotSizeFilter?.quotePrecision
        )
        const getBaseDecimal = countDecimals(
          res.data?.data?.pair?.data?.lotSizeFilter?.basePrecision
        )
        const getPriceDecimal = countDecimals(
          res.data?.data?.pair?.data?.priceFilter?.tickSize
        )
        priceObj = res.data?.data?.rate
        priceObj = {
          ...priceObj,
          baseDecimal: getBaseDecimal,
          quoteDecimal: getQuoteDecimal,
          priceDecimal: getPriceDecimal
        }
        orderBookDataCalculation(
          oldBids,
          oldAsks,
          newBids,
          newAsks,
          getBaseDecimal,
          getPriceDecimal
        )
        const symbols = createSymbolMap(res.data?.data?.symbols)
        setSymbols(() => symbols)
        setRecentTradesData(() => res.data?.data?.recentTrade?.result?.list)
        // setTime(() => res.data?.data?.pair?.data?.nextFundingRateTime)
        let pairData = res.data?.data?.pair?.data
        pairData = {
          ...pairData,
          price: (pairData?.rate?.changePer * +pairData?.lastPrice).toFixed(
            priceObj?.priceDecimal
          ),
          baseCurrency: pairData?.baseCoin,
          quoteCurrency: pairData?.quoteCoin
        }
        setPriceStatic(() => pairData?.lastPrice)
        const markets = res.data?.data?.pairs
        let currentPair = markets.find(el => el.symbol === pairData?.symbol)
        currentPair = {
          ...currentPair,
          highPrice24h: (pairData?.rate?.changePer * +currentPair?.highPrice24h).toFixed(
            priceObj?.priceDecimal
          ),
          lowPrice24h: (pairData?.rate?.changePer * +currentPair?.lowPrice24h).toFixed(
            priceObj?.priceDecimal
          )
        }
        setPairsData(() => markets)
        setPairDetails(data => {
          return {
            prevPrice: currentPair?.usdIndexPrice,
            data: pairData,
            market: currentPair,
            baseDecimal: getBaseDecimal,
            quoteDecimal: getQuoteDecimal,
            priceDecimal: getPriceDecimal,
            rate: pairData?.rate,
            pairDB: res.data?.data?.pairDB,
            fees: res.data?.data?.fees,
          }
        })
        const favAdd = markets?.filter(data =>
          myProfile?.spotFav?.some(fav => fav === data?.symbol)
        )
        setFavs(() => favAdd)
      })
      .catch(err => {
        console.log(err)
        return navigate('/')
      })
      .finally(() => {
        setPairsLoader(() => false)
      })
  }
  const ordersDataFetch = async () => {
    setOrderFetchLoading(() => true)
    const params = {
      url: `${Config.V3_API_URL}trade/get-orders`,
      method: 'GET'
    }
    const response = await makeRequest(params)
    if (response?.status) {
      // console.log(response?.data)
      setTradesPages(() => initialBackPages)
      setTrades(() => response?.data)
    } else {
    }
    setOrderFetchLoading(() => false)
  }
  const openOrdersDataFetch = async (cursorToken) => {
    setOrderFetchLoading(() => true)
    const params = {
      url: `${Config.V3_API_URL
        }trade/get-open-orders?cursor=${cursorToken}`,
      method: 'GET'
    }
    const response = await makeRequest(params)
    if (response?.status) {
      // console.log(response?.data)
      setTrades(el => {
        return { ...el, openOrders: response?.data?.openOrders }
      })
      if (cursorToken && cursorToken !== '1') {
        setTradesPages(el => {
          return { ...el, openOrders: true }
        })
      }
      else {
        setTradesPages(el => {
          return { ...el, openOrders: false }
        })
      }
    } else {
    }
    setOrderFetchLoading(() => false)
  }
  const orderHistoryDataFetch = async (cursorToken) => {
    setOrderFetchLoading(() => true)
    const params = {
      url: `${Config.V3_API_URL
        }trade/get-orderHistory?cursor=${cursorToken}`,
      method: 'GET'
    }
    const response = await makeRequest(params)
    if (response?.status) {
      // console.log(response?.data)
      setTrades(el => {
        return { ...el, orders: response?.data?.orders }
      })
      if (cursorToken && cursorToken !== '1') {
        setTradesPages(el => {
          return { ...el, orders: true }
        })
      }
      else {
        setTradesPages(el => {
          return { ...el, orders: false }
        })
      }
    } else {
    }
    setOrderFetchLoading(() => false)
  }
  const stopOrderDataFetch = async (cursorToken) => {
    setOrderFetchLoading(() => true)
    const params = {
      url: `${Config.V3_API_URL
        }trade/get-stopOrder?cursor=${cursorToken}`,
      method: 'GET'
    }
    const response = await makeRequest(params)
    if (response?.status) {
      // console.log(response?.data)
      setTrades(el => {
        return { ...el, stopOrders: response?.data?.stopOrders }
      })
      if (cursorToken && cursorToken !== '1') {
        setTradesPages(el => {
          return { ...el, stopOrders: true }
        })
      }
      else {
        setTradesPages(el => {
          return { ...el, stopOrders: false }
        })
      }
    } else {
    }
    setOrderFetchLoading(() => false)
  }
  const fillsOrderDataFetch = async (cursorToken) => {
    setOrderFetchLoading(() => true)
    const params = {
      url: `${Config.V3_API_URL}trade/get-fills?cursor=${cursorToken}`,
      method: 'GET'
    }
    const response = await makeRequest(params)
    if (response?.status) {
      // console.log(response?.data)
      setTrades(el => {
        return { ...el, fills: response?.data?.fills }
      })
      if (cursorToken && cursorToken !== '1') {
        setTradesPages(el => {
          return { ...el, fills: true }
        })
      }
      else {
        setTradesPages(el => {
          return { ...el, fills: false }
        })
      }
    } else {
    }
    setOrderFetchLoading(() => false)
  }
  useEffect(() => {
    const favAdd = pairsData.filter(data =>
      myProfile?.spotFav?.some(fav => fav === data?.symbol)
    )
    setFavs(() => favAdd)
  }, [myProfile, pairsData])

  const checkOverflow = () => {
    if (containerRef.current && containerSecondRef.current) {
      setIsOverflowing(
        containerRef.current.scrollWidth > containerRef.current.clientWidth
      )
      setIsOverflowingSecond(
        containerSecondRef.current.scrollWidth >
        containerSecondRef.current.clientWidth
      )
    }
  }

  useEffect(() => {
    checkOverflow()

    window.addEventListener('resize', checkOverflow)
    return () => {
      window.removeEventListener('resize', checkOverflow)
    }
  }, [pairsData])
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    })
    pairDataFetch()
    ordersDataFetch()
    setSpotUsdtBalance(pairName)
    // getWalletCurrency();
    $(document).ready(function () {
      $('.futures-trading-table-total-height li').mouseenter(function () {
        $(this).addClass('divider')
      })
      $('.futures-trading-table-total-height li').mouseleave(function () {
        $(this).removeClass('divider')
      })
    })
    let socket = socketIOClient(Config.SOCKET_URL, {
      // transports: ["polling"],
      transports: ['websocket']
      // rejectUnauthorized: false
    })
    let socketUnsubscribe
    if (socket) {
      socket.on('connect', function () {
        setSocketConnection(socket)
        socketUnsubscribe = socket
      })
      socket.on('connect_error', err => {
        // console.log('socket connect_error', err)
      })
      socket.on('disconnect', function () { })
    }
    return () => {
      if (socketUnsubscribe) {
        socketUnsubscribe.disconnect()
      }
    }
  }, [])
  const normalizeSymbol = (pair = "") =>
    pair.toUpperCase().replace(/[\s/_-]/g, "");

  const getTopicRoot = topic => topic?.split(".")[0] || "";
  const getTopicSymbol = topic => topic?.split(".").pop() || "";
  useEffect(() => {
    if (!pairName) return;

    const symbol = normalizeSymbol(pairName);

    const connect = () => {
      wsRef.current = new WebSocket(Config.BYBIT_SOCKET + '/spot');

      wsRef.current.onopen = () => {
        reconnectRef.current = 0;

        wsRef.current.send(
          JSON.stringify({
            op: "subscribe",
            args: [
              `tickers.${symbol}`,
              `publicTrade.${symbol}`,
              `orderbook.50.${symbol}`
            ]
          })
        );

        pingRef.current = setInterval(() => {
          if (wsRef.current?.readyState === WebSocket.OPEN) {
            wsRef.current.send(JSON.stringify({ op: "ping" }));
          }
        }, 20000);
      };

      wsRef.current.onmessage = e => {
        try {
          const msg = JSON.parse(e.data);
          if (!msg?.topic || !msg?.data) return;
          handleMessage(msg, symbol);
        } catch (err) {
          console.error("WS parse error", err);
        }
      };

      wsRef.current.onerror = () => wsRef.current?.close();

      wsRef.current.onclose = () => {
        clearInterval(pingRef.current);
        if (reconnectRef.current < 5) {
          reconnectRef.current++;
          setTimeout(connect, reconnectRef.current * 2000);
        }
      };
    };

    connect();

    return () => {
      clearInterval(pingRef.current);
      wsRef.current?.close();
      wsRef.current = null;
    };
  }, [pairName]);
  useEffect(() => {
    let socket;
    let manuallyClosed = false;

    const connectSocket = () => {
      const token = getCookie("userToken");

      if (!token) {
        // console.error("❌ User token not found");
        return;
      }

      const socketUrl =
        Config.BYBIT_SOCKET_PVT +
        "/spot?token=" +
        encodeURIComponent(token);

      socket = new WebSocket(socketUrl);
      wsRefPvt.current = socket;

      socket.onopen = () => {
      };

      socket.onmessage = (e) => {
        try {
          const data = JSON.parse(e.data);

          // console.log("📩 Bybit Private Socket Message:", data);

          handleMessageV2(data);
        } catch (error) {
          // console.error("❌ Socket message parse error:", error);
        }
      };

      socket.onerror = (error) => {
        // console.error("❌ Bybit Private Socket Error:", error);
      };

      socket.onclose = (event) => {
        // console.log("🔴 Bybit Private Socket Closed:", {
        //   code: event.code,
        //   reason: event.reason,
        //   wasClean: event.wasClean,
        //   manuallyClosed
        // });
      };
    };

    connectSocket();

    return () => {
      manuallyClosed = true;

      const currentSocket = socket;

      if (
        currentSocket &&
        (
          currentSocket.readyState === WebSocket.OPEN ||
          currentSocket.readyState === WebSocket.CONNECTING
        )
      ) {
        currentSocket.close(1000, "Component unmounted");
      }

      if (wsRefPvt.current === currentSocket) {
        wsRefPvt.current = null;
      }
    };
  }, []);
  // useEffect(() => {
  //   const socketUrl =
  //     Config.BYBIT_SOCKET_PVT +
  //     '/spot?token=' +
  //     getCookie("userToken");

  //   console.log("🔌 Connecting socket:", socketUrl);

  //   wsRefPvt.current = new WebSocket(socketUrl);

  //   wsRefPvt.current.onopen = () => {
  //     console.log("✅ Bybit Private Socket Connected");
  //     console.log(
  //       "Socket State:",
  //       wsRefPvt.current?.readyState === WebSocket.OPEN
  //         ? "OPEN"
  //         : wsRefPvt.current?.readyState
  //     );
  //   };

  //   wsRefPvt.current.onmessage = (e) => {
  //     console.log("📩 Socket Message:", JSON.parse(e.data));

  //     handleMessageV2(JSON.parse(e.data));
  //   };

  //   wsRefPvt.current.onerror = (error) => {
  //     console.error("❌ Bybit Private Socket Error:", error);
  //   };

  //   wsRefPvt.current.onclose = (event) => {
  //     console.log("🔴 Bybit Private Socket Disconnected", {
  //       code: event.code,
  //       reason: event.reason,
  //       wasClean: event.wasClean,
  //     });
  //   };

  //   return () => {
  //     console.log("🧹 Closing Bybit Private Socket");

  //     wsRefPvt.current?.close();
  //     wsRefPvt.current = null;
  //   };
  // }, []);
  const handleMessage = (msg, currentSymbol) => {
    const topicRoot = getTopicRoot(msg.topic);
    const topicSymbol = getTopicSymbol(msg.topic);

    if (topicSymbol !== currentSymbol) return;
    if (topicRoot === "orderbook") {
      const bids = msg.data?.b || [];
      const asks = msg.data?.a || [];
      if (msg.type === "snapshot" || msg.data?.u === 1) {
        orderBookDataCalculation([], [], bids, asks, priceObj?.baseDecimal, priceObj?.priceDecimal);
      }
      if (msg.type === "delta") {
        const prev = orderBookRef.current;
        if (!prev?.bids || !prev?.asks) return;
        // const oldBids = orderBookData?.bids || [];
        // const oldAsks = orderBookData?.asks || [];
        // if (!oldBids || !oldAsks || oldBids.length <= 0 || oldAsks.length <= 0) return;
        orderBookDataCalculation(prev.bids, prev.asks, bids, asks, priceObj?.baseDecimal, priceObj?.priceDecimal);
      }
    }

    if (topicRoot === "publicTrade") {
      setRecentTradesData(prev => {
        const old = Array.isArray(prev) ? prev : [];
        const merged = [...msg.data, ...old];

        return merged
          .sort((a, b) => b.T - a.T)
          .slice(0, 18);
      });
    }

    if (topicRoot === "tickers") {
      setPairDetails(prev => {
        if (!prev?.data) return prev;

        const p = priceObj?.changePer || 1;
        const d = priceObj?.priceDecimal || 2;

        return {
          ...prev,
          prevPrice: msg.data?.usdIndexPrice,
          data: {
            ...prev.data,
            lastPrice: (p * +msg.data.lastPrice).toFixed(d),
            price: (p * +msg.data.lastPrice).toFixed(d),
            highPrice24h: (p * +msg.data.highPrice24h).toFixed(d),
            lowPrice24h: (p * +msg.data.lowPrice24h).toFixed(d),
            volume24h: msg.data.volume24h,
            turnover24h: msg.data.turnover24h,
            prevPrice24h: msg.data.prevPrice24h,
            changeRate: msg.data.price24hPcnt,
            price24hPcnt: msg.data.price24hPcnt,
            usdIndexPrice: msg.data.usdIndexPrice
          },
          market: {
            ...prev.market,
            highPrice24h: (p * +msg.data.highPrice24h).toFixed(d),
            lowPrice24h: (p * +msg.data.lowPrice24h).toFixed(d),
            volume24h: msg.data.volume24h,
            turnover24h: msg.data.turnover24h,
            prevPrice24h: msg.data.prevPrice24h,
            changeRate: msg.data.price24hPcnt,
            price24hPcnt: msg.data.price24hPcnt,
            usdIndexPrice: msg.data.usdIndexPrice
          }
        };
      });
    }
  };

  useEffect(() => {
    if (socketConnection != null) {
      loadSocketExchange()
    }
  }, [socketConnection])


  const loadSocketExchange = () => {
    const userJWT = getCookie('userToken')
    if (userJWT != null && userJWT != '') {
      userTokenChk = userJWT ? userJWT : ''
      socketConnection.emit('join', { userId: userJWT })
      socketConnection.on('joined', function (data) {
        if (userJWT == data.token) {
          userTokenChk = data.userId
        }
      })
      socketConnection.on('balance', data => {
        if (data) {
          for (const el of data?.data) {
            if (userTokenChk == el?.userId) {
              ordersDataFetch()
              // if (el?.currency === 'USDT') {
              //   const getHold = spotBalance?.['trade']?.[el?.currency]?.holds
              //     ? +spotBalance?.['trade']?.[el?.currency]?.holds
              //     : 0.0
              //   dispatch({
              //     type: 'SET_SPOT_AVLBALANCE',
              //     payload: {
              //       walletBalance: el?.available?.toFixed(4),
              //       locked: getHold,
              //       currency: el?.currency
              //     }
              //   })
              // }
            }
          }
        }
      })
    }
  }
  async function handleMessageV2(message) {
    const topic = message?.topic;
    const data = message?.data;
    if (!topic || !data) return;

    if (topic === "wallet") {
      data.forEach(el => {
        el?.coin.forEach(item => {
          dispatch({
            type: "SET_SPOT_AVLBALANCE",
            payload: {
              currency: item.coin,
              walletBalance: +item.walletBalance,
              locked: +item.locked
            }
          });
        })
      });
    }

    if (topic === "order.spot") {
      data.forEach(order => {
        setTrades(prev => {
          if (!order) return prev;
          const orderId = order.orderId;
          const status = order.orderStatus;
          const stopOrderType = order?.stopOrderType;
          //non stop
          if ((!stopOrderType || stopOrderType === "") && (status === "New" || status === "PartiallyFilled")) {
            const updatedOpenOrders = prev.openOrders?.list.some(
              o => o.orderId === orderId
            )
              ? prev.openOrders?.list.map(o =>
                o.orderId === orderId ? order : o
              )
              : [order, ...prev.openOrders?.list];

            return {
              ...prev,
              openOrders: { ...prev.openOrders, list: updatedOpenOrders }
            };
          }
          if ((!stopOrderType || stopOrderType === "") && (status === "Filled" || status === "Cancelled" || status === "PartiallyFilledCanceled" || status === "Rejected")) {
            const updatedOrders = prev.orders?.list.some(
              o => o.orderId === orderId
            )
              ? prev.orders?.list.map(o =>
                o.orderId === orderId ? order : o
              )
              : [order, ...prev.orders?.list];
            return {
              ...prev,
              openOrders: {
                ...prev.openOrders, list: prev.openOrders?.list.filter(
                  o => o.orderId !== orderId
                )
              },
              orders: { ...prev.orders, list: updatedOrders }
            };
          }

          //stop
          if ((stopOrderType === "Stop" || stopOrderType === "TakeProfit" || stopOrderType === "StopLoss" || stopOrderType === 'tpslOrder') && status === "Untriggered") {
            const updatedStopOrders = prev.stopOrders?.list.some(
              o => o.orderId === orderId
            )
              ? prev.stopOrders?.list.map(o =>
                o.orderId === orderId ? order : o
              )
              : [order, ...prev.stopOrders?.list];

            return {
              ...prev,
              stopOrders: { ...prev.stopOrders, list: updatedStopOrders }
            };
          }
          if ((stopOrderType === "Stop" || stopOrderType === "TakeProfit" || stopOrderType === "StopLoss" || stopOrderType === 'tpslOrder') && (status === "Triggered" || status === "Deactivated" || status === "Activated" || status === "Rejected")) {
            const updatedOrders = prev.orders?.list.some(
              o => o.orderId === orderId
            )
              ? prev.orders?.list.map(o =>
                o.orderId === orderId ? order : o
              )
              : [order, ...prev.orders?.list];
            return {
              ...prev,
              stopOrders: {
                ...prev.stopOrders, list: prev.stopOrders?.list.filter(
                  o => o.orderId !== orderId
                )
              },
              orders: { ...prev.orders, list: updatedOrders }
            };
          }

          return prev;
        });
      })
    }
    if (topic === "execution.fast.spot") {
      data.forEach(exec => {
        setTrades(prev => {
          if (!exec) return prev;

          const execOrderId = exec.orderId;

          const updatedFills = prev.fills?.list.some(
            f => f.execId === exec.execId
          )
            ? prev.fills?.list
            : [
              {
                execId: exec.execId,
                orderId: exec.orderId,
                symbol: exec.symbol,
                side: exec.side,
                price: +exec.execPrice,
                qty: +exec.execQty,
                time: exec.execTime
              },
              ...prev.fills?.list
            ];

          return {
            ...prev,
            fills: { ...prev.fills, list: updatedFills },
            openOrders: {
              ...prev.openOrders, list: prev.openOrders?.list.map(o =>
                o.orderId === execOrderId
                  ? {
                    ...o,
                    cumExecQty:
                      (+o.cumExecQty || 0) + +exec.execQty
                  }
                  : o
              )
            }
          };
        });
      })
    }
  }
  async function cancelOrder(isWait = false, data) {
    const params = {
      url: `${Config.V3_API_URL}trade/cancel-order`,
      method: 'POST',
      body: data
    }
    const response = await makeRequest(params)
    if (response.status) {
      toast({ type: 'success', message: response.message })
      if (!isWait) {
        ordersDataFetch()
      }
      return true
    } else {
      toast({ type: 'error', message: response.message })
      return false
    }
  }
  const submitTradeWithAPI = async tradeParam => {
    if (
      myProfile &&
      ((myProfile.additionalKyc.status !== 'manually_approved' &&
        myProfile.additionalBank.status !== 'manually_approved' &&
        myProfile.additionalKyc.status !== 'auto_approved' &&
        myProfile.additionalKyc.status !== 'approved' &&
        myProfile.additionalBank.status !== 'auto_approved' &&
        myProfile.additionalBank.status !== 'approved') ||
        myProfile?.kycOffline?.aadhaar?.status != 1 ||
        myProfile?.kycOffline?.aml?.status != 1 ||
        myProfile?.kycOffline?.identity?.status != 1)
    ) {
      toast({ type: 'error', message: 'Please complete the kyc details' })
      navigate('/my/identification')
      return false
    }
    const params = {
      url: `${Config.V3_API_URL}trade/submit-spot-trade`,
      method: 'POST',
      body: { data: tradeParam }
    }
    const response = await makeRequestWithErrorMessage(params)
    if (response.status) {
      toast({ type: 'success', message: response.message })
      setUserProfile()
      ordersDataFetch()
      return true
    } else {
      toast({ type: 'error', message: response.message })
      return false
    }
  }
  const updateFavPairs = async (name, dataSingle) => {
    const params = {
      url: `${Config.V1_API_URL}user/updateSpotFav`,
      method: 'POST',
      body: { data: name }
    }
    const response = await makeRequest(params)

    if (response.status) {
      const profileSpotFav = myProfile?.spotFav || []
      if (response?.isAdd === '1') {
        dispatch({
          type: "SET_MY_SPOT_FAV",
          payload: [...profileSpotFav, name]
        });
      } else if (response?.isAdd === '0') {
        const cutDataState = profileSpotFav.filter(
          data => data !== dataSingle?.symbol
        )
        dispatch({
          type: "SET_MY_SPOT_FAV",
          payload: cutDataState
        });
      }
      // toast({ type: "success", message: response.message });
    } else {
      // toast({ type: "error", message: response.message });
    }
  }

  const fromSymbolName = (symbol, type = 0) => {
    if (!symbol || symbol == '') return null
    symbol = showPairNameUsdt(symbol, '-')
    type = parseFloat(type)
    let verify = symbol ? symbol.split('-')[type] : null
    return verify
  }
  const handleSelectedPriceOrderBook = prc => {
    if (!prc) return null
    const coinPrice = +prc
    setPriceStatic(() => coinPrice)
    const total = coinPrice * amount
    setQuantity(() =>
      total == 0 || !total || total == null
        ? null
        : total.toFixed(pairDetails?.quoteDecimal)
    )
  }

  const myOrdersDiv = (
    <div className=''>
      <SpotMyOrdersUsdt
        myProfile={myProfile}
        trades={trades}
        tradesBackPage={tradesBackPage}
        symbolsData={symbolsData}
        countDecimals={countDecimals}
        cancelOrder={cancelOrder}
        setCurrentPage_tradeHis={setCurrentPage_tradeHis}
        currentPage_tradeHis={currentPage_tradeHis}
        decimalValue={decimalValue}
        pairsLoader={pairsLoader}
        orderFetchLoading={orderFetchLoading}
        ordersDataFetch={ordersDataFetch}
        openOrdersDataFetch={openOrdersDataFetch}
        orderHistoryDataFetch={orderHistoryDataFetch}
        stopOrderDataFetch={stopOrderDataFetch}
        fillsOrderDataFetch={fillsOrderDataFetch}
      />
    </div>
  )
  const orderBooksDiv = (
    <div className='col-12 col-lg-4 col-xxl-3 h-100'>
      <div className='pt-2'>
        <div className='d-flex flex-column trading-page-top-section-2 align-items-center top-heading-total-height'>
          <div
            className='me-auto ps-2 menu-option-part-order w-100'
            style={{ gap: '10px' }}
          >
            <Typography
              component='h1'
              className={`mb-0 pt-1 pb-2 menu-option-part-order-p  ${tradesShow == 0 ? 'text-active-order' : ''
                }`}
              onClick={() => setTradesShow(() => 0)}
            >
              Order Book
            </Typography>
            <Typography
              component='h1'
              className={`mb-0 pt-1 pb-2 menu-option-part-order-p  ${tradesShow == 1 ? 'text-active-order' : ''
                }`}
              onClick={() => setTradesShow(() => 1)}
            >
              Real-Time Trades
            </Typography>
          </div>
        </div>
        {tradesShow == 0 ? (
          <div className='p-0 futures-trading-table-total-height'>
            <div className='text-end d-flex justify-content-end align-items-center orderbook-grid-tabs mt-1'>
              <ul className='nav nav-pills' id='pills-tab' role='tablist'>
                <li
                  className='nav-item'
                  role='presentation'
                  onClick={() => setOrderListType('buy')}
                >
                  <button
                    className='nav-link active'
                    id='pills-grid1-tab'
                    data-bs-toggle='pill'
                    data-bs-target='#pills-grid1'
                    type='button'
                    role='tab'
                    aria-controls='pills-grid1'
                    aria-selected='true'
                  >
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      width='20'
                      height='12'
                      viewBox='0 0 20 12'
                    >
                      <g
                        id='Rectangle_9'
                        data-name='Rectangle 9'
                        fill='none'
                        stroke='#20b958'
                        strokeLinecap='round'
                        strokeWidth='1'
                      >
                        <rect width='5' height='12' rx='0.5' stroke='none' />
                        <rect
                          x='0.5'
                          y='0.5'
                          width='4'
                          height='11'
                          fill='none'
                        />
                      </g>
                      <g
                        id='Rectangle_10'
                        data-name='Rectangle 10'
                        transform='translate(8 5) rotate(-90)'
                        fill='none'
                        stroke='#b3b7c2'
                        strokeLinecap='round'
                        strokeWidth='1'
                      >
                        <rect width='5' height='12' rx='0.5' stroke='none' />
                        <rect
                          x='0.5'
                          y='0.5'
                          width='4'
                          height='11'
                          fill='none'
                        />
                      </g>
                      <g
                        id='Rectangle_11'
                        data-name='Rectangle 11'
                        transform='translate(8 12) rotate(-90)'
                        fill='none'
                        stroke='#b3b7c2'
                        strokeLinecap='round'
                        strokeWidth='1'
                      >
                        <rect width='5' height='12' rx='0.5' stroke='none' />
                        <rect
                          x='0.5'
                          y='0.5'
                          width='4'
                          height='11'
                          fill='none'
                        />
                      </g>
                    </svg>
                  </button>
                </li>
                <li
                  className='nav-item'
                  role='presentation'
                  onClick={() => setOrderListType('sell')}
                >
                  <button
                    className='nav-link'
                    id='pills-grid2-tab'
                    data-bs-toggle='pill'
                    data-bs-target='#pills-grid2'
                    type='button'
                    role='tab'
                    aria-controls='pills-grid2'
                    aria-selected='false'
                  >
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      width='20'
                      height='12'
                      viewBox='0 0 20 12'
                    >
                      <g
                        id='Rectangle_9'
                        data-name='Rectangle 9'
                        fill='none'
                        stroke='#ff5a5a'
                        strokeLinecap='round'
                        strokeWidth='1'
                      >
                        <rect width='5' height='12' rx='0.5' stroke='none' />
                        <rect
                          x='0.5'
                          y='0.5'
                          width='4'
                          height='11'
                          fill='none'
                        />
                      </g>
                      <g
                        id='Rectangle_10'
                        data-name='Rectangle 10'
                        transform='translate(8 5) rotate(-90)'
                        fill='none'
                        stroke='#b3b7c2'
                        strokeLinecap='round'
                        strokeWidth='1'
                      >
                        <rect width='5' height='12' rx='0.5' stroke='none' />
                        <rect
                          x='0.5'
                          y='0.5'
                          width='4'
                          height='11'
                          fill='none'
                        />
                      </g>
                      <g
                        id='Rectangle_11'
                        data-name='Rectangle 11'
                        transform='translate(8 12) rotate(-90)'
                        fill='none'
                        stroke='#b3b7c2'
                        strokeLinecap='round'
                        strokeWidth='1'
                      >
                        <rect width='5' height='12' rx='0.5' stroke='none' />
                        <rect
                          x='0.5'
                          y='0.5'
                          width='4'
                          height='11'
                          fill='none'
                        />
                      </g>
                    </svg>
                  </button>
                </li>
                <li
                  className='nav-item'
                  role='presentation'
                  onClick={() => setOrderListType('all')}
                >
                  <button
                    className='nav-link'
                    id='pills-grid3-tab'
                    data-bs-toggle='pill'
                    data-bs-target='#pills-grid3'
                    type='button'
                    role='tab'
                    aria-controls='pills-grid3'
                    aria-selected='false'
                  >
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      width='20'
                      height='12'
                      viewBox='0 0 20 12'
                    >
                      <g
                        id='Rectangle_5'
                        data-name='Rectangle 5'
                        transform='translate(8)'
                        fill='none'
                        stroke='#b3b7c2'
                        strokeLinecap='round'
                        strokeWidth='1'
                      >
                        <rect width='12' height='5' rx='0.5' stroke='none' />
                        <rect
                          x='0.5'
                          y='0.5'
                          width='11'
                          height='4'
                          fill='none'
                        />
                      </g>
                      <g
                        id='Rectangle_7'
                        data-name='Rectangle 7'
                        transform='translate(8 7)'
                        fill='none'
                        stroke='#b3b7c2'
                        strokeLinecap='round'
                        strokeWidth='1'
                      >
                        <rect width='12' height='5' rx='0.5' stroke='none' />
                        <rect
                          x='0.5'
                          y='0.5'
                          width='11'
                          height='4'
                          fill='none'
                        />
                      </g>
                      <g
                        id='Rectangle_6'
                        data-name='Rectangle 6'
                        transform='translate(0 7)'
                        fill='none'
                        stroke='#20b958'
                        strokeLinecap='round'
                        strokeWidth='1'
                      >
                        <rect width='5' height='5' rx='0.5' stroke='none' />
                        <rect
                          x='0.5'
                          y='0.5'
                          width='4'
                          height='4'
                          fill='none'
                        />
                      </g>
                      <g
                        id='Rectangle_8'
                        data-name='Rectangle 8'
                        fill='none'
                        stroke='#ff5a5a'
                        strokeLinecap='round'
                        strokeWidth='1'
                      >
                        <rect width='5' height='5' rx='0.5' stroke='none' />
                        <rect
                          x='0.5'
                          y='0.5'
                          width='4'
                          height='4'
                          fill='none'
                        />
                      </g>
                    </svg>
                  </button>
                </li>
              </ul>
            </div>
            {pairsLoader ? (
              <div className='trading-page-top-section-3 '>
                <div className='' style={{ height: '480px' }}>
                  <div className='d-flex flex-row mb-1 mobile-justify-content orderbook-table-heading-section border-top-0'>
                    <div className='progress-table-1'>
                      <span className='orderbook-text-1'>Price(USDT)</span>
                    </div>
                    <div className='progress-table-2'>
                      <span className='orderbook-text-1'>Amount</span>
                    </div>
                    <div className='progress-table-3'>
                      <span className='orderbook-text-1'>Total</span>
                    </div>
                  </div>
                  <div className='h-100' style={{ marginTop: '-25px' }}>
                    <LoaderSpin />
                  </div>
                </div>
              </div>
            ) : (
              <div>
                <div className='trading-page-top-section-3 '>
                  <div className='trading-table-left-section exchange-progress-bar-bg-color'>
                    <div className='d-flex flex-row mb-1 mobile-justify-content orderbook-table-heading-section border-top-0'>
                      <div className='progress-table-1'>
                        <span className='orderbook-text-1'>Price(USDT)</span>
                      </div>
                      <div className='progress-table-2'>
                        <span className='orderbook-text-1'>Amount</span>
                      </div>
                      <div className='progress-table-3'>
                        <span className='orderbook-text-1'>Total</span>
                      </div>
                    </div>
                    <SpotOrderBookUsdt
                      handleSelectedPriceOrderBook={
                        handleSelectedPriceOrderBook
                      }
                      viewOrderList={
                        orderBookData
                          ? orderListType === 'all' || orderListType === 'sell'
                            ? orderBookData?.asks
                              ? orderBookData?.asks
                                ?.slice(0, orderListType === 'all' ? 8 : 16)
                                .reverse()
                              : []
                            : orderBookData?.bids
                              ? orderBookData?.bids
                              : []
                          : []
                      }
                      orderListType={
                        orderListType === 'all' || orderListType === 'sell'
                          ? 'sell'
                          : 'buy'
                      }
                      viewLimit={orderListType === 'all' ? 8 : 16}
                      pairDetails={null}
                      reverse={'yes'}
                      priceDeci={priceObj?.priceDecimal || pairDetails?.priceDecimal}
                      priceObj={priceObj}
                    />
                  </div>
                </div>
                {orderListType == 'all' && (
                  <div className='d-flex flex-row orderbook-table-heading-section'>
                    {pairDetails ? (
                      <div className='ps-2'>
                        <span
                          className={`${pairDetails?.data?.price >= pairDetails?.prevPrice
                            ? 'color-green-futures'
                            : 'color-red-futures'
                            } fw-bold`}
                        >
                          {pairDetails?.data?.price}
                        </span>
                      </div>
                    ) : (
                      ''
                    )}
                  </div>
                )}
                {orderListType == 'all' && (
                  <div className='trading-table-left-section exchange-progress-bar-bg-color '>
                    <SpotOrderBookUsdt
                      orderListType={'buy'}
                      viewOrderList={orderBookData?.bids}
                      viewLimit={8}
                      pairDetails={null}
                      reverse={'no'}
                      priceObj={priceObj}
                      priceDeci={priceObj?.priceDecimal || pairDetails?.priceDecimal}
                      handleSelectedPriceOrderBook={
                        handleSelectedPriceOrderBook
                      }
                    />
                  </div>
                )}
              </div>
            )}
          </div>
        ) : (
          <SpotRecentUsdt
            priceObj={priceObj}
            tradeHistory={recentTradesData}
            pairsLoader={pairsLoader}
            formatWithK={formatWithK}
          />
        )}
      </div>
    </div>
  )
  const createSubAccount = async email => {
    const response = await createTradingAccount(email)
    if (response.status) {
      toast({ type: 'success', message: response.message })
      setUserProfile()
      setSpotUsdtBalance(pairName)
    } else {
      toast({ type: 'error', message: response.message })
    }
  }
  return (
    <div className='bg-default text-white pb-0 overflow-hidden min-vh-100'>
      <NavbarOne setTheme={props.setTheme} theme={props.theme} />
      <Helmet>
        <link
          rel='canonical'
          href='https://uniticexchange.com/futures/trade/BTCUSDT'
        />
      </Helmet>
      <div className='container-fluid pt-2 setFontRoboto'>
        <div className='first-panel-futures'>
          <div className='first-div-futures'>
            <div className='marquee-container'>
              <div
                className={`futures-trade-top-section d-flex justify-content-start align-items-center overflow-auto ${isOverflowingSecond ? '' : ''
                  }`}
                style={{ gap: '15px', whiteSpace: 'nowrap' }}
                ref={containerSecondRef}
              >
                <div>
                  <SpotMenuUsdt
                    handleNavigation={handleNavigation}
                    pairsData={pairsData}
                    pairsLoader={pairsLoader}
                    pairName={pairName}
                    setOrderBookData={setOrderBookData}
                    updateFavPairs={updateFavPairs}
                    pairDetails={pairDetails}
                    favs={favs}
                    countDecimals={countDecimals}
                  />
                </div>
                <div>
                  <p
                    className={`${Number(pairDetails?.data?.price24hPcnt || '0') > 0
                      ? 'color-green-futures'
                      : 'color-red-futures'
                      } fw-bold`}
                    style={{ fontSize: '1rem' }}
                  >
                    {pairDetails.data?.lastPrice}
                  </p>
                  {/* <p className={`color-green-futures fw-bold`} style={{ fontSize: '1rem' }}>{pair?.last}</p> */}
                </div>
                <div className='rate-part'>
                  <p>24H Change</p>
                  <p className={`${Number(pairDetails?.data?.price24hPcnt || '0') > 0
                    ? 'color-green-futures'
                    : 'color-red-futures'
                    }`}>{(Number(pairDetails?.data?.price24hPcnt || '0') * 100).toFixed(2)}%</p>
                </div>
                <div className='rate-part'>
                  <p>24h High</p>
                  <p>{pairDetails?.data?.highPrice24h}</p>
                </div>
                <div className='rate-part'>
                  <p>24h Low</p>
                  <p>{pairDetails?.data?.lowPrice24h}</p>
                </div>
                <div className='rate-part'>
                  <p>24h Turnover({pairDetails?.data?.quoteCoin})</p>
                  <p>{formatNumber(pairDetails?.data?.turnover24h)}</p>
                </div>
              </div>
              <div
                className={`futures-trade-top-section futures-first-part ${isOverflowing ? 'marquee-content' : ''
                  }`}
                ref={containerRef}
                style={{ display: !favs ? 'none' : '' }}
              >
                {favs &&
                  favs.map((dataSingle, index) => (
                    <p key={index}>
                      <span
                        onClick={() => handleNavigation(dataSingle?.symbol)}
                        className='cursor-pointer'
                      >
                        {showPairNameUsdt(dataSingle?.symbol)}
                      </span>{' '}
                      <span
                        className={`${+dataSingle?.lastPrice <= +dataSingle?.usdIndexPrice
                          ? 'color-green-futures'
                          : 'color-red-futures'
                          } `}
                      >
                        {dataSingle?.lastPrice}
                      </span>
                    </p>
                  ))}
              </div>
              {/* <div className="futures-trade-top-section option-part">

                                <div onClick={() => setFirstOptionPart(0)}>
                                    <h6 className={`${firstOptionPart !== 0 ? 'futures-secondary' : ''} cursor-pointer`}>Chart</h6>
                                </div>
                                <div onClick={() => setFirstOptionPart(1)}>
                                    <h6 className={`${firstOptionPart !== 1 ? 'futures-secondary' : ''} cursor-pointer`}>Info</h6>
                                </div>
                                <div onClick={() => setFirstOptionPart(2)}>
                                    <h6 className={`${firstOptionPart !== 2 ? 'futures-secondary' : ''} cursor-pointer`}>Trading Data</h6>
                                </div>
                            </div> */}
            </div>
            <div className='row'>
              <div className='col-12 col-lg-8 col-xxl-9'>
                <div>
                  {firstOptionPart === 0 && (
                    <div id='tradingviewwidgetFutures'>
                      {pairName && !pairsLoader ? (
                        <TradingViewSpot
                          symbol={pairName}
                          theme={props.theme}
                          dec={priceObj?.priceDecimal}
                        />
                      ) : (
                        <LoaderUnitic />
                      )}
                    </div>
                  )}
                  {firstOptionPart === 1 ? (
                    <SpotInfoUsdt />
                  ) : firstOptionPart === 2 ? (
                    <SpotTradingDataUsdt />
                  ) : null}
                </div>
                {/* {window.innerWidth > 991 ? myOrdersDiv : orderBooksDiv} */}
              </div>
              {orderBooksDiv}
            </div>
            <div>{myOrdersDiv}</div>
          </div>
          <div className='second-div-futures' style={{}}>
            <div style={{ height: '42px' }}></div>
            <SpotTradeFormUsdt
              myProfile={myProfile}
              createSubAccount={createSubAccount}
              pairDetails={pairDetails}
              priceStatic={priceStatic}
              setPriceStatic={setPriceStatic}
              walletData={walletData}
              submitTrade={submitTradeWithAPI}
              spotBalance={spotBalance}
              fromSymbolName={fromSymbolName}
              handleClickOpenOrderConfirmation={
                handleClickOpenOrderConfirmation
              }
              amount={amount}
              setAmount={setAmount}
              quantity={quantity}
              setQuantity={setQuantity}
            />
          </div>
        </div>
        {/* <div>
                    {myOrdersDiv}
                </div> */}
      </div>
      {openOrderConfirmation && (
        <OrderConfirmationUsdt
          open={openOrderConfirmation}
          handleClickOpen={handleClickOpenOrderConfirmation}
          handleClose={handleCloseOrderConfirmation}
          tradeParams={tradeParams}
          submitTrade={submitTradeWithAPI}
          amount={amount}
          setAmount={setAmount}
          quantity={quantity}
          setQuantity={setQuantity}
        />
      )}
      {openModifyOrder && (
        <ModifyOrderUsdt
          open={openModifyOrder}
          handleClickOpen={handleClickOpenModifyOrder}
          handleClose={handleCloseModifyOrder}
        />
      )}
      {openModifyMargin && (
        <ModifyMarginUsdt
          open={openModifyMargin}
          handleClickOpen={handleClickOpenModifyMargin}
          handleClose={handleCloseModifyMargin}
        />
      )}
      {openAdjust && (
        <AdjustLeverageUsdt
          open={openAdjust}
          handleClickOpen={handleClickOpenAdjust}
          handleClose={handleCloseAdjust}
          xMenu={xMenu}
          setXMenu={setXMenu}
          pairDetails={pairDetails}
          pairName={pairName}
          formatSymbolName={formatSymbolName}
        />
      )}
      {openMarginMode && (
        <MarginModeUsdt
          open={openMarginMode}
          handleClickOpen={handleClickOpenMarginMode}
          handleClose={handleCloseMarginMode}
          crossMenu={crossMenu}
          setCrossMenu={setCrossMenu}
        />
      )}
    </div>
  )
}

export default SpotTradeUsdt
